import { render, staticRenderFns } from "./AddCourseDetails.vue?vue&type=template&id=d17f7224"
import script from "./AddCourseDetails.vue?vue&type=script&lang=js"
export * from "./AddCourseDetails.vue?vue&type=script&lang=js"
import style0 from "./AddCourseDetails.vue?vue&type=style&index=0&id=d17f7224&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports